import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  Alert
} from "react-bootstrap";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import "../../../style/subAdmin/UserDetails.scss";
import { createBrowserHistory } from "history";
import { NewBreadcrumb as BreadcrumbComponent } from "../../../components";
import isEmpty from "lodash.isempty";
import { Notification } from "../../../components/notifications";
import {
  get_merchant_details,
  get_merchant_location_details
} from "../../../redux/actions/merchantActions";
import loader from "../../../style/loader/loader.scss";
import "../../../style/detailPage.scss";
import {aclUtil} from "../../util"

const history = createBrowserHistory();
let isLoading = "false";
class MerchantDetails extends Component {
  static contextTypes = {
    router: PropTypes.object
  }
  constructor(props) {
    const viewLink = (props.match && props.match.params) && `merchantDetails/${props.match.params.userId}`
    super(props);
    this.state = {
      menuKey: 'VIEW_MERCHANT',
      merchantDetails: {},
      merchantLocationDetails: [],
      path: ["Home", "Manage Merchant", "Merchant Details"],
      links:["home", "merchantList", viewLink],
      showLocations: false,
      salesmanagerdata: {}
    };
  }

  handleRenderLocation = () => {
    this.setState({ showLocations: true });
  };

  componentWillMount() {
    let merchantIdParams = this.props.match.params.userId
      ? this.props.match.params.userId
      : "";
    if (merchantIdParams !== "") {
      isLoading = "true";
      this.props.get_merchant_details(merchantIdParams);
    }
  }

  componentWillReceiveProps(nextProps) {
    if(!aclUtil.isPrimaryMenuAccessible(this.state.menuKey)){
      this.context.router.history.push("/restrictedAccess");
    }
    if (
      this.props.merchantDetails !== nextProps.merchantDetails &&
      !isEmpty(nextProps.merchantDetails)
    ) {
      const merchantID =
        nextProps.merchantDetails && nextProps.merchantDetails.merchant_id;
      if (merchantID !== "") {
        isLoading = "false";
      }
      this.setState({ merchantDetails: nextProps.merchantDetails });
      this.setState({
        salesmanagerdata: nextProps.merchantDetails.salesManager
      });
      this.props.get_merchant_location_details(merchantID);
    }
    if (
      this.props.merchantLocationDetails !==
        nextProps.merchantLocationDetails &&
      !isEmpty(nextProps.merchantLocationDetails)
    ) {
      this.setState({
        merchantLocationDetails: nextProps.merchantLocationDetails.data
      });
    }

    if (this.props.error !== nextProps.error) {
      if (nextProps.error) {
        isLoading = "false";
      }
    }
  }

  render() {
    let merchantlocationsData = this.state.merchantLocationDetails
      ? this.state.merchantLocationDetails
      : "";
    let merchantData =
      this.state.merchantDetails && this.state.merchantDetails
        ? this.state.merchantDetails
        : {};
    let salesdata = this.state.salesmanagerdata
      ? this.state.salesmanagerdata
      : "";

    let merchantLocations;
    if (merchantlocationsData) {
      merchantLocations = merchantlocationsData.map((phylocation, idx) => (
        <div className="panel">
          <header className="panel-heading">
            {" "}
            Physical Location {idx + 1}
          </header>
          <div id={idx} className="panel-body detail-Page">
            <Row>
              <Col md={6}>
                <label className="titles-name">Address1</label>
              </Col>
              <Col md={6}>
                <p className="values-name">{phylocation.locAddress1}</p>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <label className="titles-name">Address2</label>
              </Col>
              <Col md={6}>
                <p className="values-name">{phylocation.locAddress2}</p>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <label className="titles-name">Tax</label>
              </Col>
              <Col md={6}>
                <p className="values-name">{phylocation.taxPerc}</p>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <label className="titles-name">Phone</label>
              </Col>
              <Col md={6}>
                <p className="values-name">{phylocation.locPhone}</p>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <label className="titles-name">Latitude</label>
              </Col>
              <Col md={6}>
                <p className="values-name">{phylocation.locLatitude}</p>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <label className="titles-name">Longitude</label>
              </Col>
              <Col md={6}>
                <p className="values-name">{phylocation.locLongitude}</p>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <label className="titles-name">City</label>
              </Col>
              <Col md={6}>
                <p className="values-name">{phylocation.locCity}</p>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <label className="titles-name">State</label>
              </Col>
              <Col md={6}>
                <p className="values-name">{phylocation.locState}</p>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <label className="titles-name">Country</label>
              </Col>
              <Col md={6}>
                <p className="values-name">{phylocation.locCountry}</p>
              </Col>
            </Row>
          </div>
        </div>
      ));
    }

    return (
      <div>
        {isLoading == "true" ? (
          <div className="loader">
            <p className="loading-message">
              <i>Loading...</i>
            </p>
            <div className="spinner">
              <div className="dot1" />
              <div className="dot2" />
            </div>
          </div>
        ) : (
          ""
        )}
        <div className="row">
          <div className="col-xs-12">
            <BreadcrumbComponent path={this.state.path} links={this.state.links} context={this.context} />
          </div>
        </div>

        <div className="col-lg-12 detail-Page">
          <div className="row">
            <div className="col-lg-12 text-right">
              <Button
                bsSize="small"
                bsStyle="success"
                onClick={() =>
                  this.context.router.history.push(`/merchant/dashboard/${merchantData.user_id}`)
                }
              >
                Dashboard
              </Button>
            </div>
          </div>

          <div className="panel">
            <header className="panel-heading">Merchant Information</header>
            <div className="panel-body">

              <Row>
                <Col md={3} xs={6}>
                  <FormGroup controlId="formBasicUserNameText">
                    <ControlLabel> Merchant Name : </ControlLabel>
                  </FormGroup>

                  <FormGroup controlId="formBasicEmailText">
                    <ControlLabel>Legal Name :</ControlLabel>
                  </FormGroup>
                  <FormGroup controlId="formBasicFirstNameText">
                    <ControlLabel>Website Url :</ControlLabel>
                  </FormGroup>
                  <FormGroup controlId="formBasicLastNameText">
                    <ControlLabel> Facebook Page :</ControlLabel>
                  </FormGroup>
                  <FormGroup controlId="formBasicDOBText">
                    <ControlLabel>Twitter Page :</ControlLabel>
                  </FormGroup>
                </Col>

                <Col md={3} xs={6}>
                  <FormGroup controlId="formBasicUserNameText">
                    <ControlLabel className="values-name">
                      {" "}
                      {merchantData.merchantName}{" "}
                    </ControlLabel>
                  </FormGroup>

                  <FormGroup controlId="formBasicEmailText">
                    <ControlLabel className="values-name">
                      {merchantData.legalName}
                    </ControlLabel>
                  </FormGroup>
                  <FormGroup controlId="formBasicFirstNameText">
                    <ControlLabel>{merchantData.websiteUrl} </ControlLabel>
                  </FormGroup>
                  <FormGroup controlId="formBasicLastNameText">
                    <ControlLabel className="values-name">
                      {" "}
                      {merchantData.facebookPage}{" "}
                    </ControlLabel>
                  </FormGroup>
                  <FormGroup controlId="formBasicDOBText">
                    <ControlLabel className="values-name">
                      {merchantData.twitterPage}{" "}
                    </ControlLabel>
                  </FormGroup>
                </Col>
                <Col md={3} xs={6}>
                  <FormGroup controlId="formBasicAddressTwoText">
                    <ControlLabel>Meta Keywords :</ControlLabel>
                  </FormGroup>

                  <FormGroup controlId="formBasicAddressTwoText">
                    <ControlLabel>Meta Description :</ControlLabel>
                  </FormGroup>

                  <FormGroup controlId="formBasicAddressTwoText">
                    <ControlLabel>VAT Exempt? :</ControlLabel>
                  </FormGroup>

                  <FormGroup controlId="formBasicZipText">
                    <ControlLabel>Payment Terms? :</ControlLabel>
                  </FormGroup>
                  <FormGroup controlId="formControlsStatusSelect">
                    <ControlLabel>Default Tax % :</ControlLabel>
                  </FormGroup>
                  {merchantData.bankInfo === 1 && (
                    <div>
                      <FormGroup controlId="formControlsBankName">
                        <ControlLabel>Bank Name :</ControlLabel>
                      </FormGroup>
                      <FormGroup controlId="formControlsRoutingNumber">
                        <ControlLabel>Bank Routing Number :</ControlLabel>
                      </FormGroup>
                      <FormGroup controlId="formControlsAccountNumber">
                        <ControlLabel>Bank Account Number :</ControlLabel>
                      </FormGroup>
                    </div>
                  )}
                </Col>
                <Col md={3} xs={6}>
                  <FormGroup controlId="formBasicAddressTwoText">
                    <ControlLabel className="values-name">
                      {" "}
                      {merchantData.metaKeywords}{" "}
                    </ControlLabel>
                  </FormGroup>

                  <FormGroup controlId="formBasicAddressTwoText">
                    <ControlLabel className="values-name">
                      {" "}
                      {merchantData.metaDesc}{" "}
                    </ControlLabel>
                  </FormGroup>

                  <FormGroup controlId="formBasicAddressTwoText">
                    <ControlLabel className="values-name">
                      {" "}
                      {merchantData.vatExempt === 0 ? "No" : "Yes"}{" "}
                    </ControlLabel>
                  </FormGroup>

                  <FormGroup controlId="formBasicZipText">
                    <ControlLabel className="values-name">
                      {merchantData.paymentTerms}{" "}
                    </ControlLabel>
                  </FormGroup>
                  <FormGroup controlId="formControlsStatusSelect">
                    <ControlLabel className="values-name">
                      {" "}
                      {merchantData.defaultTaxPerc}{" "}
                    </ControlLabel>
                  </FormGroup>
                  {merchantData.bankInfo === 1 && (
                    <div>
                      <FormGroup controlId="formControlsBankNameData">
                        <ControlLabel className="values-name">
                          {merchantData.bankName}
                        </ControlLabel>
                      </FormGroup>
                      <FormGroup controlId="formControlsRoutingNumberData">
                        <ControlLabel className="values-name">
                          {merchantData.bankRoutingNum}
                        </ControlLabel>
                      </FormGroup>
                      <FormGroup controlId="formControlsBankAccNoData">
                        <ControlLabel className="values-name">
                          {merchantData.bankAccountNo}
                        </ControlLabel>
                      </FormGroup>
                    </div>
                  )}
                </Col>
              </Row>
            </div>
          </div>

          <div className="panel">
            <header className="panel-heading">
              PRIMARY CONTACT INFORMATION
            </header>
            <div className="panel-body">
              <Row>
                <Col md={3} xs={6}>
                  <FormGroup controlId="formBasicUserNameText">
                    <ControlLabel> User Name :</ControlLabel>
                  </FormGroup>

                  <FormGroup controlId="formBasicEmailText">
                    <ControlLabel> Email :</ControlLabel>
                  </FormGroup>
                  <FormGroup controlId="formBasicFirstNameText">
                    <ControlLabel> Phone : </ControlLabel>
                  </FormGroup>
                  <FormGroup controlId="formBasicLastNameText">
                    <ControlLabel> First Name :</ControlLabel>
                  </FormGroup>
                  <FormGroup controlId="formBasicDOBText">
                    <ControlLabel> Last Name : </ControlLabel>
                  </FormGroup>
                  <FormGroup controlId="formControlsSelect">
                    <ControlLabel> Date Of Birth : </ControlLabel>
                  </FormGroup>

                  <FormGroup controlId="formControlsStatusSelect">
                    <ControlLabel>Status : </ControlLabel>
                  </FormGroup>
                </Col>

                <Col md={3} xs={6}>
                  <FormGroup controlId="formBasicUserNameText">
                    <ControlLabel className="values-name">
                      {" "}
                      {merchantData.userName}{" "}
                    </ControlLabel>
                  </FormGroup>

                  <FormGroup controlId="formBasicEmailText">
                    <ControlLabel> {merchantData.email} </ControlLabel>
                  </FormGroup>
                  <FormGroup controlId="formBasicFirstNameText">
                    <ControlLabel className="values-name">
                      {" "}
                      {merchantData.phone}{" "}
                    </ControlLabel>
                  </FormGroup>
                  <FormGroup controlId="formBasicLastNameText">
                    <ControlLabel className="values-name">
                      {" "}
                      {merchantData.firstName}
                    </ControlLabel>
                  </FormGroup>
                  <FormGroup controlId="formBasicDOBText">
                    <ControlLabel className="values-name">
                      {" "}
                      {merchantData.lastName}{" "}
                    </ControlLabel>
                  </FormGroup>
                  <FormGroup controlId="formControlsSelect">
                    <ControlLabel className="values-name">
                      {" "}
                      {merchantData.dob}{" "}
                    </ControlLabel>
                  </FormGroup>

                  <FormGroup controlId="formControlsStatusSelect">
                    <ControlLabel className="values-name">
                      {" "}
                      {merchantData.status}{" "}
                    </ControlLabel>
                  </FormGroup>
                </Col>

                <Col md={3} xs={6}>
                  <FormGroup controlId="formBasicAddressOneText">
                    <ControlLabel> Address1 : </ControlLabel>
                  </FormGroup>
                  <FormGroup controlId="formBasicAddressTwoText">
                    <ControlLabel>Address2 : </ControlLabel>
                  </FormGroup>

                  <FormGroup controlId="formBasicAddressTwoText">
                    <ControlLabel>Country : </ControlLabel>
                  </FormGroup>

                  <FormGroup controlId="formBasicAddressTwoText">
                    <ControlLabel>State :</ControlLabel>
                  </FormGroup>

                  <FormGroup controlId="formBasicAddressTwoText">
                    <ControlLabel>City :</ControlLabel>
                  </FormGroup>

                  <FormGroup controlId="formBasicZipText">
                    <ControlLabel> Zipcode :</ControlLabel>
                  </FormGroup>
                </Col>
                <Col md={3} xs={6}>
                  <FormGroup controlId="formBasicAddressOneText">
                    <ControlLabel className="values-name">
                      {" "}
                      {merchantData.address1}{" "}
                    </ControlLabel>
                  </FormGroup>
                  <FormGroup controlId="formBasicAddressTwoText">
                    <ControlLabel className="values-name">
                      {" "}
                      {merchantData.address2}{" "}
                    </ControlLabel>
                  </FormGroup>

                  <FormGroup controlId="formBasicAddressTwoText">
                    <ControlLabel className="values-name">
                      {" "}
                      {merchantData.country}{" "}
                    </ControlLabel>
                  </FormGroup>

                  <FormGroup controlId="formBasicAddressTwoText">
                    <ControlLabel className="values-name">
                      {" "}
                      {merchantData.state}{" "}
                    </ControlLabel>
                  </FormGroup>

                  <FormGroup controlId="formBasicAddressTwoText">
                    <ControlLabel className="values-name">
                      {" "}
                      {merchantData.city}{" "}
                    </ControlLabel>
                  </FormGroup>

                  <FormGroup controlId="formBasicZipText">
                    <ControlLabel className="values-name">
                      {" "}
                      {merchantData.zipcode}{" "}
                    </ControlLabel>
                  </FormGroup>
                </Col>
              </Row>
            </div>
          </div>

          <div className="panel">
            <header className="panel-heading">
              {" "}
              SECONDARY CONTACT INFORMATION{" "}
            </header>
            <div className="panel-body">
              <Row>
                <Col md={6} xs={12}>
                  <FormGroup controlId="formBasicLastNameText">
                    <ControlLabel> First Name :</ControlLabel>
                  </FormGroup>
                  <FormGroup controlId="formBasicDOBText">
                    <ControlLabel> Last Name : </ControlLabel>
                  </FormGroup>
                  <FormGroup controlId="formControlsSelect">
                    <ControlLabel>Email: </ControlLabel>
                  </FormGroup>

                  <FormGroup controlId="formBasicPhoneText">
                    <ControlLabel> Phone : </ControlLabel>
                  </FormGroup>
                </Col>

                <Col md={6} xs={12}>
                  <FormGroup controlId="formBasicLastNameText">
                    <ControlLabel className="values-name">
                      {" "}
                      {merchantData.secondaryContactFirstName}
                    </ControlLabel>
                  </FormGroup>
                  <FormGroup controlId="formBasicDOBText">
                    <ControlLabel className="values-name">
                      {" "}
                      {merchantData.secondaryContactLastName}{" "}
                    </ControlLabel>
                  </FormGroup>
                  <FormGroup controlId="formControlsSelect">
                    <ControlLabel>
                      {" "}
                      {merchantData.secondaryContactEmail}{" "}
                    </ControlLabel>
                  </FormGroup>

                  <FormGroup controlId="formBasicPhoneText">
                    <ControlLabel className="values-name">
                      {" "}
                      {merchantData.secondaryContactPhone}{" "}
                    </ControlLabel>
                  </FormGroup>
                </Col>
              </Row>
            </div>
          </div>

          <div className="panel">
            <header className="panel-heading">
              {" "}
              TERTIARY CONTACT INFORMATION{" "}
            </header>
            <div className="panel-body">
              <Row>
                <Col md={6} xs={12}>
                  <FormGroup controlId="formBasicLastNameText">
                    <ControlLabel> First Name :</ControlLabel>
                  </FormGroup>
                  <FormGroup controlId="formBasicDOBText">
                    <ControlLabel> Last Name : </ControlLabel>
                  </FormGroup>
                  <FormGroup controlId="formControlsSelect">
                    <ControlLabel>Email: </ControlLabel>
                  </FormGroup>

                  <FormGroup controlId="formBasicPhoneText">
                    <ControlLabel> Phone : </ControlLabel>
                  </FormGroup>
                </Col>

                <Col md={6} xs={12}>
                  <FormGroup controlId="formBasicLastNameText">
                    <ControlLabel className="values-name">
                      {" "}
                      {merchantData.tertiaryContactFirstName}
                    </ControlLabel>
                  </FormGroup>
                  <FormGroup controlId="formBasicDOBText">
                    <ControlLabel className="values-name">
                      {" "}
                      {merchantData.tertiaryContactLastName}{" "}
                    </ControlLabel>
                  </FormGroup>
                  <FormGroup controlId="formControlsSelect">
                    <ControlLabel>
                      {" "}
                      {merchantData.tertiaryContactEmail}{" "}
                    </ControlLabel>
                  </FormGroup>

                  <FormGroup controlId="formBasicPhoneText">
                    <ControlLabel className="values-name">
                      {" "}
                      {merchantData.tertiaryContactPhone}{" "}
                    </ControlLabel>
                  </FormGroup>
                </Col>
              </Row>
            </div>
          </div>

          <div className="panel">
            <header className="panel-heading"> ADMINISTRATIVE OPTION </header>
            <div className="panel-body">
              <Row>
                <Col md={6} xs={12}>
                  <FormGroup controlId="formBasicLastNameText">
                    <ControlLabel> Sales Person :</ControlLabel>
                  </FormGroup>
                </Col>
                <Col md={6} xs={12}>
                  <FormGroup controlId="formBasicLastNameText">
                    <ControlLabel className="values-name">
                      {" "}
                      {salesdata.firstName}&nbsp;{salesdata.lastName}
                    </ControlLabel>
                  </FormGroup>
                </Col>
              </Row>
            </div>
          </div>

          <br />
          {merchantlocationsData !== "" &&
          merchantlocationsData.length !== 0 ? (
            <Button
              bsStyle="link"
              onClick={this.handleRenderLocation.bind(this)}
            >
              Physical Locations
            </Button>
          ) : (
            ""
          )}
          <br />
          {this.state.showLocations &&
            merchantlocationsData &&
            merchantLocations}
          <Row className="BtnRow">
            <Col md={12} xs={12}>
              <Button
                bsStyle="info"
                onClick={() => this.context.router.history.push(`/merchantList`)}
              >
                {" "}
                Back
              </Button>
            </Col>
          </Row>

          <div className="clearfix" />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  merchantDetails: state.merchantReducer.merchantDetails,
  error: state.merchantReducer.error,
  merchantLocationDetails: state.merchantReducer.merchantLocationDetails
});
export default compose(
  withRouter, // IMPORTANT: witRouter is "needed here" to avoid blocking routing:
  connect(mapStateToProps, {
    get_merchant_details,
    get_merchant_location_details
  })
)(MerchantDetails);



// WEBPACK FOOTER //
// ./src/app/views/admin/merchant/MerchantDetails.js